import { Dialog, DialogTitle } from "@mui/material";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import type { UUID } from "../../../../utils/uuid";
import { isEmailChannel, type ChannelName } from "../../../channels/types";
import { SendTestToEmail } from "../../../moment/component/buttons/send-test/send-test-to-email";
import { SendTestToRecipient } from "../../../moment/component/buttons/send-test/send-test-to-recipient";

interface DialogProps {
  open: boolean;
  id: UUID;
  channel: NonNullable<ChannelName>;
  onCancel: () => void;
  saving: boolean;
  setSaving: (value: boolean) => void;
  setTestDialog: (value: boolean) => void;
}

export const FollowUpSendTestDialog: FC<DialogProps> = ({
  open,
  id,
  channel,
  onCancel,
  saving,
  setSaving,
  setTestDialog,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{t("Send Test")}</DialogTitle>
      {isEmailChannel(channel) ? (
        <SendTestToEmail
          id={id}
          setSaving={setSaving}
          publishing={saving}
          setTestDialog={setTestDialog}
        />
      ) : (
        <SendTestToRecipient
          id={id}
          setSaving={setSaving}
          publishing={saving}
          setTestDialog={setTestDialog}
          channel={channel}
        />
      )}
    </Dialog>
  );
};
